import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
@Component({
    selector: 'litmus-list-viewer',
    templateUrl: './litmus-list-viewer.component.html',
    styleUrls: ['./litmus-list-viewer.component.scss'],
    standalone: false
})
export class LitmusListViewerComponent implements OnChanges {
  @Input() list:any = [];
  @Input() type:string = '';
  @Output() click:any = new EventEmitter<any>();
  @Output() remove:any = new EventEmitter<any>();
  itemList:any = []
  ngOnChanges(changes: SimpleChanges): void {
    this.itemList = (typeof this.list == 'string')?JSON.parse(this.list):this.list
  }
  onClick(event:any,item:any){
    event.stopPropagation();
    this.click.emit(item);
  }
  onRemove(event:any,item:any){
    event.stopPropagation();
    this.remove.emit(item);
  }
}
